import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

const OrderList = ({ orders, onSelect }) => {
  return (
    <List>
      <ListItem
        style={{
          borderBottom: '1px solid #a1a1a1',
          backgroundColor: '#000',
          color: '#fff',
        }}
      >
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Submission Date
          </Typography>
        </ListItemIcon>
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Staples Shipped Date
          </Typography>
        </ListItemIcon>
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Stock Received Date
          </Typography>
        </ListItemIcon>
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            BOT Shipped Date
          </Typography>
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography variant="h6" style={{ color: '#fff', fontSize: 14 }}>
              PO
            </Typography>
          }
        />

        <ListItemText
          primary={
            <Typography variant="h6" style={{ color: '#fff', fontSize: 14 }}>
              Total Quantity
            </Typography>
          }
        />
        <ListItemSecondaryAction style={{ color: '#fff' }}>
          <Typography
            style={{
              width: 200,
              color: '#fff',
              textAlign: 'right',
              fontSize: 14,
            }}
            variant="h6"
          >
            Status
          </Typography>
        </ListItemSecondaryAction>
      </ListItem>
      {orders.map((value) => {
        let quantity = 0;

        for (let i = 0; i < value?.lineItems.length; i++) {
          quantity += Number(value?.lineItems[i].qty);
        }
        return (
          <ListItem
            key={value.ID}
            role={undefined}
            dense
            button
            style={{ borderBottom: '1px solid #a1a1a1' }}
            onClick={() => onSelect(value)}
          >
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value.submissionDate}
              </Typography>
            </ListItemIcon>
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.staplesShipDate
                  ? moment(value?.staplesShipDate).format('MMM-DD-YYYY')
                  : null}
              </Typography>
            </ListItemIcon>
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.lineItems[0]?.stockReceivedDate
                  ? moment(value?.lineItems[0]?.stockReceivedDate).format(
                      'MMM-DD-YYYY'
                    )
                  : null}
              </Typography>
            </ListItemIcon>
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.lineItems[0]?.botShipDate
                  ? moment(value?.lineItems[0]?.botShipDate).format(
                      'MMM-DD-YYYY'
                    )
                  : null}
              </Typography>
            </ListItemIcon>

            <ListItemText
              primary={
                <Typography
                  variant="h6"
                  style={{ width: 200, color: '#000', fontSize: 14 }}
                >
                  ID : {value.ID}
                </Typography>
              }
            />
            <ListItemText
              primary={
                <Typography
                  variant="h6"
                  style={{ width: 200, color: '#000', fontSize: 14 }}
                >
                  {quantity}
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Typography
                style={{
                  width: 200,
                  color: '#000',
                  textAlign: 'right',
                  fontSize: 14,
                }}
                variant="h6"
              >
                {value.status}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default OrderList;
